import React from 'react';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { orderDashboardPath } from 'utils/paths';
import lockSrc from './icon-lock.svg';

const text = {
  lockedModel:
    'Model is temporarily inaccessible. It is currently being viewed/edited.',
  backToDashboard: 'Back to Dashboard',
};

const LockedWarning = ({ lockedBackground }) => (
  <div className={styles.lockedWarning} style={lockedBackground}>
    <div className={styles.lockIcon}>
      <img src={lockSrc} alt="" />
    </div>
    <div>{text.lockedModel}</div>
    <div>
      <Link to={orderDashboardPath} className={styles.button}>
        <span>{text.backToDashboard}</span>
      </Link>
    </div>
  </div>
);

export default LockedWarning;
